<template>
   <div
   class="grid-item"
   :class="`grid-${size}`"
   v-scroll-reveal>
    <div class="top-border" :style="{backgroundColor: color}"></div>
    <div class="text-content">
      <slot />
    </div>
   </div>
</template>

<script>
export default {
  props: {
    'size': { type: String, default: '25' },
    'color': { type: String }
  }

}
</script>

<style lang="scss" scoped>
.grid-item {
  height: min-content;
  padding: $grid-gap 10%;
  position: relative;

  .top-border {
    display: block;
    width: 100%;
    height: 3px;
    position: absolute;
    top: 0;
    left: 0;
  }

  h1 {
    font-family: $display-font;
    font-size: 1.25rem;
    color: $gray7;
    margin-bottom: 1rem;
  }

  p {
    color: $gray5;
  }

  a {
    font-weight: 800;
    position: relative;
    z-index: 1;
    transition: all 0.1s ease-in-out;
    text-decoration: none;
    white-space: pre;

    &:before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      bottom: 0;
      left: -0.125em;
      right: -0.125em;
      background-color: $gray3;
      transform-origin: bottom center;
      transform: scaleY(0.1);
      transition: all 0.1s ease-in-out;
    }

    &:hover {
      color: $white;

      &:before {
        transform: scaleY(1);
        background-color: $gray8;
      }
    }
  }
}

.grid-75 {
  display: flex;
  align-items: center;
  flex-direction: column;

  .text-content {
    max-width: 600px;
  }
}
</style>
